import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Renders schema.org JSON-LD markup inside <head> via react-helmet-async.
 *
 * Two shapes supported:
 *   <SchemaMarkup faqs={[{question, answer}, ...]} />
 *   <SchemaMarkup article={{headline, description, path, datePublished, dateModified}} />
 *
 * Both can be combined in one render tree — just mount two instances.
 */
const SITE = 'https://cashifygcmart.com';

const FaqSchema = ({ faqs }) => {
  if (!Array.isArray(faqs) || faqs.length === 0) return null;
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer,
      },
    })),
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

const ArticleSchema = ({ article }) => {
  if (!article || !article.headline) return null;
  const url = `${SITE}${article.path || '/'}`;
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.headline,
    description: article.description || article.headline,
    mainEntityOfPage: { '@type': 'WebPage', '@id': url },
    url,
    datePublished: article.datePublished || '2024-01-01',
    dateModified: article.dateModified || new Date().toISOString().slice(0, 10),
    author: {
      '@type': 'Organization',
      name: 'CashifyGCMart',
      url: SITE,
    },
    publisher: {
      '@type': 'Organization',
      name: 'CashifyGCMart',
      logo: {
        '@type': 'ImageObject',
        url: `${SITE}/favicon.svg`,
      },
    },
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

const SchemaMarkup = ({ faqs, article }) => (
  <>
    {faqs ? <FaqSchema faqs={faqs} /> : null}
    {article ? <ArticleSchema article={article} /> : null}
  </>
);

export default SchemaMarkup;
